import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-acm-vehicles/src/gatsby-theme-vehicles/components/preview/components/image';
import { StaticImage } from 'gatsby-plugin-image';
import { useVehicle } from 'gatsby-theme-vehicles/src/components/vehicle-context';

const Overlay = () => (
  <div css="position: absolute; bottom: 0; left: 0; right: 0">
    <StaticImage layout="constrained" width={526} src="../../../../images/24mnd.png" alt="24 maanden garantie" />
  </div>
);

const AutobedrijfBoksPreviewImage = (props) => {
  const { customWarranty } = useVehicle();
  const showImage = (customWarranty?.data?.customWarranty || customWarranty) === '24 Maanden Garantie Boks';

  return (
    <span css="position: relative">
      <Image
        css="border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;" // reapply this :first-child style
        {...props}
        append={showImage ? <Overlay /> : null}
      />
    </span>
  );
};

export default styled(AutobedrijfBoksPreviewImage)``;
